import axios from "axios";

export const uncoveryApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const setupInterceptors = (keycloak: any) => {
  // Add or refresh token
  uncoveryApi.interceptors.request.use(async (config) => {
    if (keycloak?.token) {
      try {
        if (keycloak.isTokenExpired()) {
          await keycloak.updateToken(30);
        }
        config.headers = config.headers ?? {};
        config.headers.Authorization = `Bearer ${keycloak.token}`;
      } catch (e) {
        return Promise.reject(e);
      }
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }
    return config;
  });

  uncoveryApi.interceptors.response.use(
    (r) => r,
    (error) => {
      if (error?.response?.status === 401) {
      }
      return Promise.reject(error);
    }
  );
};

export default uncoveryApi;
